<template>
    <div class="modal-form-wrap">
        <div class="modal-form-overflow" @click="closeContactModal()"></div>
        <form ref="vform" class="form" @submit.prevent="submit">
            <div class="close-modal icon-cross" @click="closeContactModal()"></div>

            <div class="wrap">
                <div class="title-wrap">
                    <div class="title">Contact Us</div>
                </div>

                <fieldscontact :items="form" @returnStatusToParent="statusParentHandler"></fieldscontact>

                <div class="row">
                    <div class="col wide">
                        <div class="info-text" v-if="$store.state.submitStatusModal === 'ERROR' || $store.state.submitStatusModal === 'OK' || $store.state.submitStatusModal === 'PENDING'">
                            <div class="success" v-if="$store.state.submitStatusModal === 'OK'">
                                <div class="icon-cross close" @click="$store.state.submitStatusModal = null"></div>
                                Thanks for your submission!
                            </div>
                            <div class="error-wrap" v-if="$store.state.submitStatusModal === 'ERROR'">
                                <div class="icon-cross close" @click="$store.state.submitStatusModal = null"></div>
                                Some required fields are missing. Please fix them.
                            </div>
                            <div class="typo__p" v-if="$store.state.submitStatusModal === 'PENDING'">Sending...</div>
                        </div>
                    </div>
                </div>

                <vue-recaptcha :sitekey="recapthcakey"
                               data-badge="inline"
                               ref="recaptcha"
                               size="invisible"
                               @verify="onVerify"></vue-recaptcha>
            </div>
        </form>
    </div>
</template>

<script>
    import fieldscontact from "./fieldscontactmodal.vue";
    import Vue from 'vue'
    import { mapState } from 'vuex'
    import Vuelidate from 'vuelidate'
    import { required, email } from 'vuelidate/lib/validators'
    import VueRecaptcha from 'vue-recaptcha';
    import VueScrollTo from 'vue-scrollto'
    import VueMask from 'v-mask'

    Vue.use(VueMask);
    Vue.use(Vuelidate);
    Vue.use(VueScrollTo);

    export default {
        name: 'ContactModal',
        components: {
            'vue-recaptcha': VueRecaptcha,
            fieldscontact
        },
        props: [
            'formtype',
            'recapthcakey',
            'form',
            'actionprops',
            'form_id'
        ],
        data() {
            return {
                captcha: '',
                childHasError: true,
                stateDump: {}
            }
        },
        validations() {

        },
        methods: {
            closeContactModal() {
                this.$store.state.contactModalActive = false
                this.$store.state.noscrollActive = false
            },
            submit() {
                console.log('ContactModal submit start. State:', this.$store.state)
                this.childHasError = true
                this.$eventPool.$emit("touchChildFormModal")

                this.$nextTick(() => {
                    if (this.childHasError) {
                        this.$refs.recaptcha.execute();
                    } else {
                        this.$store.state.submitStatusModal = 'ERROR';
                    }
                })
            },
            onVerify: function (response) {
                console.log('ContactModal onVerify start. State:', this.$store.state)
                this.$store.state.submitStatusModal = 'PENDING';

                let formData = new FormData();
                formData.append('g-recaptcha-response', response);
                formData.append('form_type', 'contact');
                formData.append('form_id', this.form_id);

                const currentForm = { 'Contact form': this.$store.state.currentForm['Contact form'] };
                // const currentForm = this.$store.state.currentForm
                Object.keys(currentForm).forEach((item) => {
                    if (typeof currentForm[item] === 'object') {
                        formData.append(item, JSON.stringify(currentForm[item]))
                    } else {
                        formData.append(item, currentForm[item])
                    }
                })

                axios.post(this.actionprops, formData)
                    .then(response => {
                        console.log('message', response);

                        if (response.data.result === 'ok') {
                            this.$store.state.submitStatusModal = 'OK';

                            formData = new FormData();
                            this.childHasError = true;
                            this.$store.state.currentForm = {};
                            this.$refs.vform.reset();
                            this.$eventPool.$emit("resetChildForm");

                        }

                        if (response.data.result === 'error') {
                            this.$store.state.submitStatusModal = 'ERROR';
                        }

                        this.$refs.recaptcha.reset();
                    })
                    .catch(error => {
                        console.log(error)
                        this.$refs.recaptcha.reset();
                    });
            },
            status(validation) {
                return {
                    error: validation.$error,
                    dirty: validation.$dirty
                }
            },
            statusParentHandler(isValid) {
                this.childHasError = this.childHasError && isValid
            },
        }
    }
</script>

<style scoped lang="scss">
    .form .info-text {
        margin-top: 0;
    }
    .modal-form-overflow {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        z-index: 999;
    }
    .modal-form-wrap .form {
        position: fixed;
        top: 50%;
        left: 50%;
        width: 100%;
        transform: translate(-50%, -50%);
        height: auto;
        max-width: 576px;
        max-height: calc(100vh - 40px);
        min-height: 0;
        margin: 0;
        padding: 70px 50px 70px 70px;
        background: #fff;
        overflow-y: auto;
        overflow-x: hidden;
        border: 1px solid #E4E4E4;
        box-sizing: border-box;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
        border-radius: 4px;
        z-index: 1000;
    }
    .modal-form-wrap .form .close-modal {
        position: fixed;
        top: 65px;
        right: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 50px;
        padding: 0;
        background: #242424;
        border-radius: 50%;
        font-size: 17px;
        cursor: pointer;
        z-index: 99;
    }
    .modal-form-wrap  .form .wrap {
        width: 100%;
        margin-left: -20px;
    }
    .modal-form-wrap .title-wrap {
        max-width: 800px;
        margin: 0 auto 30px;
        padding-left: 20px;
    }
    .modal-form-wrap .form .field-wrap {
        max-width: 800px;
        margin: 0 auto;
    }
    .modal-form-wrap .form:before {
        content: none;
    }
    .modal-form-wrap .form .title {
        padding-right: 30px;
        font-family: "open_sansbold", sans-serif;
        font-size: 36px;
        line-height: 46px;
    }
    @media (max-width: 769px) {
        .modal-form-wrap .form {
            padding: 40px 10px 40px 30px;
        }
        .modal-form-wrap .form .close-modal {
            top: 40px;
            right: 20px;
            width: 40px;
            height: 40px;
            font-size: 18px;
        }
    }

</style>
